import { render, staticRenderFns } from "./ImportOrdersForm.vue?vue&type=template&id=04339a60"
import script from "./ImportOrdersForm.vue?vue&type=script&lang=js"
export * from "./ImportOrdersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports